import React, { useState, useEffect } from 'react';
import WebModal from './Modal';
import { isPausedOrder } from '@/biz/order';
import { useTranslation } from 'react-i18next';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { Button } from 'aha-components';
import { isMobile } from '@/biz/tool';
import { OrderStatus } from '@/interface/order';

interface Props {}

const pausedModalImageSrc = '/paused-modal-img.png';

const ModalPausedTip: React.FC<Props> = () => {
  const { t } = useTranslation();
  const { detailData } = useDetailDataStore();
  const [showModalPausedTip, setShowModalPausedTip] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = pausedModalImageSrc;
  }, []);

  useEffect(() => {
    const isPaused =
      isPausedOrder({
        status: detailData?.order?.status,
        cancelType: detailData?.order?.cancelType,
        campaignStatus: detailData?.campaign?.status
      }) ||
      (detailData?.order?.status === OrderStatus.Pending &&
        detailData?.order?.pendingType === 'PersonaNotMatch');

    setShowModalPausedTip(isPaused);
  }, [detailData]);

  return (
    <>
      <WebModal
        width={isMobile() ? 380 : 570}
        className="bg-gradient-to-b from-[#EAE9E8] to-[#fff]"
        visible={showModalPausedTip}
        isShowHeader={false}
        isShowFooter={false}
      >
        <div className="w-full max-h-[70vh] overflow-y-auto">
          <div className="flex h-[186px] justify-center">
            <img
              className="h-[186px] w-[248px] object-contain"
              src={pausedModalImageSrc}
              alt="paused"
              width={248}
              height={186}
              loading="eager"
              decoding="async"
            />
          </div>
          <div>
            <div className="w-full text-center mb-3">
              <div className="text-center justify-start text-xl font-semibold leading-8">
                {t('modal.paused.paused_title', {
                  defaultValue: 'This campaign is temporarily on hold'
                })}
              </div>
            </div>
            <div className="text-base font-normal text-[#79716B] text-center felx flex-col">
              <div className="">
                {t('modal.paused.paused_desc_1', {
                  defaultValue:
                    "The brand has paused new invites for this campaign. This doesn't affect any of your active collaborations. We'll let you know if this invite becomes available again."
                })}
              </div>
            </div>
          </div>
          <div className="mt-8 flex items-end justify-end border-t border-[#E5E7EB] pt-4">
            <Button
              type="primary"
              className="!w-[120px]"
              onClick={() => setShowModalPausedTip(false)}
            >
              {t('modal.paused.btn_text', {
                defaultValue: 'Got it'
              })}
            </Button>
          </div>
        </div>
      </WebModal>
    </>
  );
};

export default ModalPausedTip;
